import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogItemCategoryDTOBase } from "./CatalogItemCategoryDTOBase";
import type { CatalogItemRef } from "./CatalogItemRef";
import type { CatalogItemStaff } from "./CatalogItemStaff";
import type { CategoryRef } from "./CategoryRef";
import type { CategoryStaff } from "./CategoryStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class CatalogItemCategoryStaff implements CatalogItemCategoryDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly item: CatalogItemStaff | null, public readonly categoryId: CategoryStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly itemTargetIds: CatalogItemRef, public readonly categoryIdTargetIds: CategoryRef) {
    this.cbiServiceContext = null;
    this.itemLoaded = this.item != null;
    this.itemCached = this.item;
    this.categoryIdLoaded = this.categoryId != null;
    this.categoryIdCached = this.categoryId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private itemLoaded: boolean;
  private itemCached: CatalogItemStaff | null;
  private categoryIdLoaded: boolean;
  private categoryIdCached: CategoryStaff | null;
  async itemLazy(): Promise<CatalogItemStaff> {
    if (!this.itemLoaded) {
      this.itemCached = await this.cbiServiceContext!.catalogService().getCatalogItemStaff(this.itemTargetIds.assignId);
      this.itemLoaded = true;
    }
    return this.itemCached!;
  }
  async categoryIdLazy(): Promise<CategoryStaff> {
    if (!this.categoryIdLoaded) {
      this.categoryIdCached = await this.cbiServiceContext!.catalogService().getCategoryStaff(this.categoryIdTargetIds.assignId);
      this.categoryIdLoaded = true;
    }
    return this.categoryIdCached!;
  }
}
